import { AxiosInstance } from 'axios';

let accessToken: string | undefined;

/** Token do portal (SmartPass/gov.br) injetado pelo shell via Webgate. */
export function setAccessToken(token?: string): void {
  accessToken = token;
}

export function registerInterceptors(instance: AxiosInstance): void {
  instance.interceptors.request.use((config) => {
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  });
}
